import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import store from './app/store';
import App from './app/App';
import AppErrorBoundary from './app/components/utils/AppErrorBoundary';
import './assets/styles/index.css';
import reportWebVitals from './reportWebVitals'
import './app/utils/i18n';
import { setAccessToken, setRefreshToken, ensureCurrentUserTokens } from './app/utils/authStorage';
import { initGlobalErrorHandling } from './app/utils/errorHandling';

const url = new URL(window.location.href);
const params = url.searchParams;
const tokenFromQuery = params.get('token');
const refreshTokenFromQuery = params.get('refresh_token');

if (tokenFromQuery) {
    setAccessToken(tokenFromQuery);
    params.delete('token');
}

if (refreshTokenFromQuery) {
    setRefreshToken(refreshTokenFromQuery);
    params.delete('refresh_token');
}

if (tokenFromQuery || refreshTokenFromQuery) {
    const cleanUrl = url.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', cleanUrl);
}

ensureCurrentUserTokens();
initGlobalErrorHandling();


if (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp && typeof window.Telegram.WebApp.showAlert === 'function') {
    if (!window.Telegram.WebApp.init_data && !window.Telegram.WebApp.initData) {
        window.Telegram.WebApp.showAlert = (msg) => alert(msg);
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <React.StrictMode>
        <HelmetProvider>
            <Provider store={store}>
                <AppErrorBoundary>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </AppErrorBoundary>
            </Provider>
        </HelmetProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
